import Grid from 'components/core/Grid';
import styled from 'styled-components';

export const UserAvatarWrap = styled(Grid)`
    .avatar-menu-list-item {
        padding: 8px;
        border-radius: 8px;
        &:hover {
            background: #fdefed;
        }
    }
`;
